enum EstadosFormularioDocumento {
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosFormularioDocumento };
